import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUserAccess } from '../hooks/useUserAccess';

// Gate da rota /dre-consolidado: visão consolidada (somente leitura) do DRE.
// Autorizado a diretoria (por default) e DECON (por atribuição) — canReadDreGlobal.
function DreConsolidadoGuard({ children }) {
  const { canReadDreGlobal, loading } = useUserAccess();

  if (loading) {
    return (
      <div className="status-card" style={{ textAlign: 'center', padding: 40 }}>
        <span className="status-title">Verificando permissões...</span>
      </div>
    );
  }

  if (!canReadDreGlobal) {
    return <Navigate to="/" replace />;
  }

  return children;
}

export default DreConsolidadoGuard;
